import React from 'react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
export function Impact() {
  return <section className="w-full bg-ink py-28 sm:py-36 lg:py-48" aria-labelledby="impact-title" data-id="element-93" data-mp="3207qmpessvp9">
      <div className="mx-auto max-w-page px-5 sm:px-10 lg:px-12" data-id="element-94" data-mp="3fzqkcd6v44i1">
        <Reveal data-id="element-95" data-mp="3bwu7z47x14mj">
          <h2 id="impact-title" className="max-w-3xl font-sans text-[2rem] font-light uppercase leading-[1.06] text-ivory sm:text-5xl xl:text-[3.8rem]" data-id="element-96" data-mp="3bwaohj2ma86e">
            No tienes que decidir hoy.
          </h2>
          <p className="mt-6 max-w-2xl font-serif text-2xl italic leading-snug text-champagne sm:text-4xl" data-id="element-97" data-mp="3kvxsmcmqds35">
            Solo tienes que estar dispuesto/a a conocer.
          </p>
        </Reveal>

        <Reveal delay={0.1} data-id="element-98" data-mp="3upy4cxcipvku">
          <p className="mt-12 max-w-xl border-t border-ivory/15 pt-10 font-sans text-[17px] font-light leading-relaxed text-steel-200 sm:text-lg" data-id="element-99" data-mp="chyxfd7l2aqp">
            Haz tus preguntas, conoce cómo funciona y decide si esta
            oportunidad conecta con tus metas.
          </p>
        </Reveal>

        <Reveal delay={0.14} data-id="element-100" data-mp="21d35ztu8ym8i">
          <CtaButton label="Agendar una conversación" tone="champagne" className="mt-12" data-id="element-101" data-mp="21eea5urltw05" />
        </Reveal>
      </div>
    </section>;
}